export default "__VITE_ASSET__R6SC0zLQ__"